import type { NetworkError, ServerError } from '@axios-extensions/plugins-api'
import { ClientError, createApi, HeaderRequestInterceptor, HttpStatusCode, JwtBearerTokenRequestInterceptor, RefreshTokenResponseInterceptor } from '@axios-extensions/plugins-api'

export const AuthRoutes = [
  '/api/auth/refresh',
  '/api/auth/login',
]

export const { api, installInterceptor } = createApi({
  enableErrorHandler: true,
  baseURL: () => useConfigStore().apiUrl.value,
  interceptors: [
    JwtBearerTokenRequestInterceptor(
      () => useAuthStore().token.value || '',
      AuthRoutes,
    ),
    AcceptLangaugeInterceptor(),
    HeaderRequestInterceptor(() => ({ 'Content-Type': 'application/merge-patch+json' }), 'patch'),
    HeaderRequestInterceptor(() => ({ 'Content-Type': 'application/ld+json' }), 'put'),
    HeaderRequestInterceptor(() => ({ 'Content-Type': 'application/ld+json' }), 'post'),
  ],
})

const { authenticate } = createAuthenticatePlugin({
  axios: api,
  path: AuthPath.JSON_REFRESH_V2,
  onAuthenticateSuccess,
  onAuthenticateFailed,
})

async function onAuthenticateFailed(e: ClientError | ServerError | NetworkError) {
  if (e instanceof ClientError && e.status === HttpStatusCode.UNAUTHORIZED) {
    return useAuthStore().reset()
  }

  throw e
}

export async function refreshToken() {
  const refreshToken = useAuthStore().refreshToken.value
  if (!refreshToken) {
    throw new Error('No refresh token set.')
  }

  await authenticate({
    refresh_token: refreshToken,
  })
}

const refreshTokenInterceptorPlugin = RefreshTokenResponseInterceptor(
  api,
  refreshToken,
  AuthRoutes,
)

installInterceptor(refreshTokenInterceptorPlugin)

export default api
